import { Suspense, lazy } from 'react';

import SidebarLayout from 'src/layouts/SidebarLayout';
import SuspenseLoader from 'src/components/SuspenseLoader';
import { ProtectedRoute } from './security/ProtectedRoute';
import { AuthRoute } from './security/AuthRoute';

export interface RouteObject {
  path: string;
  element: JSX.Element;
  children?: RouteObjectChildren[];
}

export interface RouteObjectChildren {
  path: string;
  element: JSX.Element;
  isAdminOnly?: boolean;
}

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

const Home = Loader(lazy(() => import('src/content/pages/Home')));

const FormBuild = Loader(lazy(() => import('src/content/pages/FormBuild')));

const FormCreate = Loader(
  lazy(() => import('src/content/pages/FormBuild/Create'))
);

const FormDetail = Loader(
  lazy(() => import('src/content/pages/FormBuild/Detail'))
);

const Region = Loader(lazy(() => import('src/content/pages/Region')));

const RegionCreate = Loader(
  lazy(() => import('src/content/pages/Region/Create'))
);

const RegionDetail = Loader(
  lazy(() => import('src/content/pages/Region/Detail'))
);


const Client = Loader(lazy(() => import('src/content/pages/Client')));

const ClientCreate = Loader(
  lazy(() => import('src/content/pages/Client/Create'))
);

const ClientDetail = Loader(
  lazy(() => import('src/content/pages/Client/Detail'))
);

const Vacancy = Loader(lazy(() => import('src/content/pages/Vacancy')));

const VacancyCreate = Loader(
  lazy(() => import('src/content/pages/Vacancy/Create'))
);

const VacancyDetail = Loader(
  lazy(() => import('src/content/pages/Vacancy/Detail'))
);

const VacancyCandidate = Loader(
  lazy(() => import('src/content/pages/Vacancy/Candidate'))
);

const Candidate = Loader(lazy(() => import('src/content/pages/Candidate')));

const CandidateCreate = Loader(
  lazy(() => import('src/content/pages/Candidate/Create'))
);

const CandidateDetail = Loader(
  lazy(() => import('src/content/pages/Candidate/Detail'))
);

const CandidateEdit = Loader(
  lazy(() => import('src/content/pages/Candidate/Edit'))
);

const User = Loader(lazy(() => import('src/content/pages/User')));

const UserDetail = Loader(lazy(() => import('src/content/pages/User/Detail')));

const UserCreate = Loader(lazy(() => import('src/content/pages/User/Create')));

const Search = Loader(lazy(() => import('src/content/pages/Search')));

const Detail = Loader(lazy(() => import('src/content/pages/Detail')));

const Blank = Loader(lazy(() => import('src/content/pages/Blank')));

const CallBack = Loader(lazy(() => import('src/content/pages/Callback/index')));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Blank />
  },
  {
    path: '/callback',
    element: <CallBack />
  },
  {
    path: '/',
    element: (
      <AuthRoute>
        <SidebarLayout />
      </AuthRoute>
    ),
    children: [
      {
        path: 'home',
        element: <Home />
      },
      {
        path: 'users',
        element: (
          <ProtectedRoute>
            <User />
          </ProtectedRoute>
        )
      },
      {
        path: 'users/create',
        element: (
          <ProtectedRoute>
            <UserCreate />
          </ProtectedRoute>
        )
      },
      {
        path: 'users/:id',
        element: (
          <ProtectedRoute>
            <UserDetail />
          </ProtectedRoute>
        )
      },
      {
        path: 'forms',
        element: (
          <ProtectedRoute>
            <FormBuild />
          </ProtectedRoute>
        )
      },
      {
        path: 'forms/create',
        element: (
          <ProtectedRoute>
            <FormCreate />
          </ProtectedRoute>
        )
      },
      {
        path: 'forms/:id',
        element: (
          <ProtectedRoute>
            <FormDetail />
          </ProtectedRoute>
        )
      },
      {
        path: 'regions',
        element: (
          <ProtectedRoute>
            <Region />
          </ProtectedRoute>
        )
      },
      {
        path: 'regions/create',
        element: (
          <ProtectedRoute>
            <RegionCreate />
          </ProtectedRoute>
        )
      },
      {
        path: 'regions/:id',
        element: (
          <ProtectedRoute>
            <RegionDetail />
          </ProtectedRoute>
        )
      },
       {
        path: 'clients',
        element: (
          <ProtectedRoute>
            <Client />
          </ProtectedRoute>
        )
      },
      {
        path: 'clients/create',
        element: (
          <ProtectedRoute>
            <ClientCreate />
          </ProtectedRoute>
        )
      },
      {
        path: 'clients/:id',
        element: (
          <ProtectedRoute>
            <ClientDetail />
          </ProtectedRoute>
        )
      },
      {
        path: 'vacancies',
        element: (
          <ProtectedRoute>
            <Vacancy />
          </ProtectedRoute>
        )
      },
      {
        path: 'vacancies/create',
        element: (
          <ProtectedRoute>
            <VacancyCreate />
          </ProtectedRoute>
        )
      },
      {
        path: 'vacancies/:id',
        element: (
          <ProtectedRoute>
            <VacancyDetail />
          </ProtectedRoute>
        )
      },
      {
        path: 'vacancies/:id/candidate',
        element: (
          <ProtectedRoute>
            <VacancyCandidate />
          </ProtectedRoute>
        )
      },
      {
        path: 'candidates',
        element: (
          <ProtectedRoute>
            <Candidate />
          </ProtectedRoute>
        )
      },
      {
        path: 'candidates/create',
        element: (
          <ProtectedRoute>
            <CandidateCreate />
          </ProtectedRoute>
        )
      },
      {
        path: 'candidates/:id',
        element: (
          <ProtectedRoute>
            <CandidateDetail />
          </ProtectedRoute>
        )
      },
      {
        path: 'candidates/:id/edit',
        element: (
          <ProtectedRoute>
            <CandidateEdit />
          </ProtectedRoute>
        )
      },
      {
        path: 'search/:id',
        element: <Detail />
      },
      {
        path: 'search',
        element: <Search />
      }
    ]
  }
];

export default routes;
